import { useState } from 'react';
import {
  useGenerateSecurePaymentTokenMutation,
  useGetOrderDetailsMutation,
} from '@flysync/shared-redux/services/booking';

type SecurePaymentInput = {
  amount: number;
  user_info: Record<string, unknown>;
  trackId: string;
  type: string;
  auth: string;
};

export const useSecurePayment = () => {
  const [generateSecurePaymentToken] = useGenerateSecurePaymentTokenMutation();
  const [getOrderDetails] = useGetOrderDetailsMutation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const processSecurePayment = async (input: SecurePaymentInput) => {
    try {
      setLoading(true);
      setError(null);

      const securePaymentToken = await generateSecurePaymentToken({
        data: input,
        auth: input.auth,
      }).unwrap();

      const orderDetails = await getOrderDetails({
        data: {
          ...input,
          order_id: input.trackId,
          securePaymentToken: securePaymentToken?.data?.securePaymentToken,
        },
        auth: input.auth,
      }).unwrap();

      if (orderDetails?.data?.redirectUrl) {
        window.location.assign(orderDetails.data.redirectUrl);
      }

      return orderDetails;
    } catch (caughtError) {
      const message =
        caughtError instanceof Error
          ? caughtError.message
          : 'Secure payment failed';

      setError(message);
      throw caughtError;
    } finally {
      setLoading(false);
    }
  };

  return {
    processSecurePayment,
    loading,
    error,
  };
};
